import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";

interface PhoneInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  value: string | null;
  onChange: (value: string) => void;
  error?: string;
}

export function PhoneInput({
  value,
  onChange,
  error,
  className,
  ...props
}: PhoneInputProps) {
  const [inputValue, setInputValue] = useState("");

  const formatPhoneNumber = (value: string) => {
    // Remove todos os caracteres não numéricos
    const numbers = value.replace(/\D/g, '');

    // Se não tiver números, retorna vazio
    if (!numbers) return '';

    // Formata o número
    if (numbers.length <= 2) {
      return numbers;
    } else if (numbers.length <= 6) {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
    } else if (numbers.length <= 10) {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 6)}-${numbers.slice(6)}`;
    } else {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7, 11)}`;
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    // Remove todos os caracteres não numéricos
    const numbers = newValue.replace(/\D/g, '');
    setInputValue(formatPhoneNumber(numbers));
    onChange(numbers);
  };

  useEffect(() => {
    if (value) {
      setInputValue(formatPhoneNumber(value));
    }
  }, [value]);

  return (
    <Input
      {...props}
      type="tel"
      value={inputValue}
      onChange={handleChange}
      placeholder="(48) 99999-9999"
      className={cn(
        "font-mono",
        error && "border-red-500 focus-visible:ring-red-500",
        className
      )}
    />
  );
} 